import axios from "../../../axios";

export const getOfferList = () => {
  const response = axios.get(`orders/discounts/`);
  return response;
};

export const getOfferData = (id: any) => {
  const response = axios.get(`orders/discounts/${id}/`);
  return response;
};
